import { useMemo, useState } from "react";

const AssignRolesForm = ({
  onClose,
  onSave,
  currentRoles = [],
  availableRoles = [],
}) => {

  const [selectedRoles, setSelectedRoles] = useState(currentRoles.map(r => r.roleName));
  const selectedLevel = "app";

  const roles = useMemo(() => {
    if (Array.isArray(availableRoles) && availableRoles.length > 0) {
      return availableRoles.map((r) => r.name).filter(Boolean);
    }
    return [];
  }, [availableRoles]);

  // Handle checkbox toggle
  const handleCheckboxChange = (role) => {
    if (selectedRoles.includes(role)) {
      // Remove role if already selected
      setSelectedRoles(selectedRoles.filter((r) => r !== role));
    } else {
      // Add role if not selected
      setSelectedRoles([...selectedRoles, role]);
    }
  };

  const handleSave = async () => {
    if (!onSave) return onClose();
    const ok = await onSave(selectedRoles, selectedLevel);
    if (ok !== false) onClose();
  };

  return (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-6 relative">
      <button 
          onClick={onClose} 
          className="absolute top-3 right-3 text-[#DC1F00] hover:bg-[#DC1F0033] p-3 rounded-full"
      >
        ✖
      </button>
      <h2 className="text-xl text-[#3A4149] font-semibold mb-4">Assign Roles</h2>
      <div className="h-[1px] bg-[#a15d33]"></div>
    
      <div className="flex-1 px-6 pt-4">
        <label className="block text-sm text-[#00000080] mb-2">Level</label>
        <div className="text-sm text-textGray mb-4">App</div>

        <label className="block text-sm text-[#00000080] mb-2 mt-6">Roles<span className="text-textGray">*</span></label>
        <div className="space-y-2 mb-6">
          {roles.length === 0 ? (
            <p className="text-sm text-gray-500">No roles available</p>
          ) : roles.map((role) => (
            <label
              key={role}
              className="flex items-center text-base cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selectedRoles.includes(role)}
                onChange={() => handleCheckboxChange(role)}
                className="w-4 h-4 accent-[#DC1F00] mr-2"
              />
              {role}
            </label>
          ))}
        </div>

        <div className="flex items-center justify-between gap-4">
          <button
              onClick={onClose}
              className="w-full border-2 border-buttonWhite hover:bg-buttonWhite-hover text-[#DC1F00] px-4 py-2 rounded-full"
          >
          Cancel
          </button>
          <button
              onClick={handleSave}
              className="w-full bg-buttonRed hover:bg-buttonRed-hover text-white px-4 py-2 font-semibold rounded-full"
          >
          Save
          </button>
        </div>
      </div>
    </div>
  </div>
  )
};

export default AssignRolesForm;
